export default "__VITE_ASSET__C9y_tBDH__"